module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mentor-profile"
  }, [(_vm.connect == true) ? _c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.connect = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-box",
    style: ({
      backgroundImage: 'url(' + _vm.mentor.featuredImage + ')'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.mentor.avatar
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.mentor.user.firstName) + " " + _vm._s(_vm.mentor.user.lastName))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request),
      expression: "request"
    }],
    domProps: {
      "value": (_vm.request)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.request = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendRequest()
      }
    }
  }, [_vm._v("Submit")])])]) : _vm._e(), _vm._v(" "), (_vm.mentor) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "row mentor-header",
    style: ({
      backgroundImage: 'url(' + _vm.mentor.featuredImage + ')'
    })
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.mentor.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.mentor.user.firstName) + " " + _vm._s(_vm.mentor.user.lastName) + ", ")]), _vm._v(" "), _c('span', {
    staticClass: "position"
  }, [_vm._v("\n                        " + _vm._s(_vm.mentor.position) + "\n                    ")]), _vm._v(" "), (_vm.mentor.companyUrl) ? _c('span', [_vm._v("\n                        , \n                    ")]) : _vm._e(), _vm._v(" "), (_vm.mentor.companyUrl) ? _c('a', {
    staticClass: "company",
    attrs: {
      "href": _vm.mentor.companyUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.mentor.company) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.mentor.status === 'available') ? _c('span', {
    staticClass: "availability"
  }, [_vm._v("Available to mentor " + _vm._s(_vm.availableDays) + ", " + _vm._s(_vm.availableTimes) + ", " + _vm._s(_vm.venue))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "specialties"
  }, _vm._l((_vm.mentor.specialties), function(specialty) {
    return _c('li', [_vm._v("\n                            " + _vm._s(_vm._f("deslugify")(specialty)) + "\n                        ")])
  })), _vm._v(" "), (_vm.localStorage.roles.includes('OnlineDirector') || _vm.localStorage.roles.includes('CampusDirector')) ? _c('div', {
    staticClass: "public-status"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mentor.public),
      expression: "mentor.public"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.mentor.public) ? _vm._i(_vm.mentor.public, null) > -1 : (_vm.mentor.public)
    },
    on: {
      "change": function($event) {
        _vm.updateMentor()
      },
      "__c": function($event) {
        var $$a = _vm.mentor.public,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.mentor.public = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.mentor.public = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.mentor.public = $$c
        }
      }
    }
  }), _vm._v(" Visible on Public Website")])]) : _vm._e(), _vm._v(" "), (_vm.mentor.status === 'available' && _vm.isCorrectVenue && _vm.mentor.user.mentees.length < _vm.mentor.seats) ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.tooltipText),
      expression: "tooltipText"
    }],
    staticClass: "connect",
    class: {
      'disabled': !_vm.connectionAllowed
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.connectToMentor()
      }
    }
  }, [_vm._v("\n                        Connect\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "current-mentees"
  }, [_c('span', [_vm._v("Mentees Confirmed:")]), _vm._v(" "), _vm._l((_vm.mentor.availabilities), function(a) {
    return _c('div', {
      staticClass: "term-availability"
    }, [_c('div', [_vm._v("\n                                " + _vm._s(a.term.name.split(',')[1].trim()) + "\n                            ")]), _vm._v(" "), _c('div', [(a.status === 'available') ? _c('ul', _vm._l((a.seats), function(n) {
      return _c('li', [_c('span', {
        staticClass: "checkbox"
      }, [_c('i', {
        staticClass: "fa fa-check",
        class: {
          'green': (n - 1) < a.connections.length
        }
      })])])
    })) : (a.status === 'unavailable') ? _c('ul', _vm._l((a.seats), function(n) {
      return _c('li', [_vm._m(0, true)])
    })) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h3', [_vm._v("Biography")]), _vm._v(" "), _c('div', {
    staticClass: "bio",
    domProps: {
      "innerHTML": _vm._s(_vm.mentor.bio)
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "links"
  }, _vm._l((_vm.mentor.socialSites), function(site) {
    return _c('li', [_c('a', {
      attrs: {
        "href": site.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(site.site))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [(_vm.mentor.demoReelUrl && _vm.demoReelAccessible) ? _c('vue-media-embed', {
    attrs: {
      "source": _vm.mentor.demoReelUrl,
      "allow-fullscreen": 1
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.mentor.featuredImage
    }
  })], 1)]), _vm._v(" "), (_vm.mentor.gallery.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('h3', [_vm._v("Work Samples")]), _vm._v(" "), _c('ul', {
    staticClass: "gallery work-samples"
  }, _vm._l((_vm.mentor.gallery), function(image, $index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.openLightbox(_vm.mentor.gallery, $index)
        }
      }
    }, [_c('v-lazy-image', {
      attrs: {
        "src": image
      }
    })], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.mentor.credits.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('h3', [_vm._v("Credits Include")]), _vm._v(" "), _c('ul', {
    staticClass: "gallery credits"
  }, _vm._l((_vm.mentor.credits), function(image, $index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.openLightbox(_vm.mentor.credits, $index)
        }
      }
    }, [_c('v-lazy-image', {
      attrs: {
        "src": image
      }
    })], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.mentor.pastMentoredStudents.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Past Mentored Students")]), _vm._v(" "), _c('ul', {
    staticClass: "past-students"
  }, _vm._l((_vm.mentor.pastMentoredStudents), function(student) {
    return _c('li', [_c('div', {
      staticClass: "header"
    }, [_c('div', {
      staticClass: "avatar-wrapper"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": student.avatar
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('h4', [_vm._v(_vm._s(student.name))]), _vm._v(" "), (student.artstation) ? _c('ul', {
      staticClass: "links"
    }, [_c('li', [_c('a', {
      attrs: {
        "href": student.artstation,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(student.artstation))])])]) : _vm._e()])]), _vm._v(" "), _c('div', [_c('ul', {
      staticClass: "images"
    }, _vm._l((student.images), function(image, $index) {
      return _c('li', {
        on: {
          "click": function($event) {
            _vm.openLightbox(student.images, $index)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": image
        }
      })])
    }))])])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.lightboxImages) ? _c('div', {
    staticClass: "lightbox",
    on: {
      "click": function($event) {
        _vm.lightboxImages = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": function($event) {
        _vm.lightboxImages = null
      }
    }
  }), _vm._v(" "), _c('swiper', {
    ref: "lightbox",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.lightboxImages), function(slide) {
    return _c('swiper-slide', [_c('img', {
      attrs: {
        "src": slide
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev swiper-button-white",
    attrs: {
      "slot": "button-prev"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-button-white",
    attrs: {
      "slot": "button-next"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "button-next"
  })], 2)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox",
    attrs: {
      "title": "Mentor is not available for this term"
    }
  }, [_c('i', {
    staticClass: "fa fa-remove red"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bb1c5ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MentorProfile.vue
// module id = 2041
// module chunks = 2